<template lang="pug">
  .my-points-entry-container(@click="handleClick")
    .title 我的奖励金
    .amount {{ points }}
    img.icon-arrow(src="https://m.hellobike.com/ea127146e9.png")
</template>

<script>
export default {
  name: 'PageTab',
  props: {
    points: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {
    // 点击积分信息
    handleClick() {
      this.$emit('pointsClick');
    }
  },
};
</script>

<style lang="less" scoped>
.my-points-entry-container {
  display: flex;
  align-items: flex-end;

  .amount {
    margin-left: 0.08rem;
    font-family: 'DIN Alternate Bold', sans-serif;
    font-size: 0.18rem;
    color: #000;
    transform: translateY(0.01rem);
  }

  .icon-arrow {
    margin-left: 0.06rem;
    width: 0.045rem;
    height: 0.08rem;
    vertical-align: bottom;
    transform: translateY(-0.04rem);
  }
}
</style>
